<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G. H. Raisoni Memorial & H2E Power Systems Maharashtra State Under-11 Open and Girls Selection
                        FIDE Rated Chess Championships</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G.H. Raisoni Memorial & h2e Power Systems Maharashtra State Under-11 Open & Girls Selection FIDE
                    Rated Chess Championship 2026</span></h2>
        </div>

        <p><strong>Date: </strong>10–12 July 2026</p>
        <p><strong>Venue: </strong>Janata Mahavidyalaya, Chandrapur</p>
        <p><strong>Organized By: </strong>Creative Chess Association, Chandrapur</p>
        <p><strong>Total Prize Fund: </strong>₹40,000</p>

        <p>The G.H. Raisoni Memorial & h2e Power Systems Maharashtra State Under-11 Open & Girls Selection FIDE Rated
            Chess Championship 2026 was successfully held from 10–12 July 2026 at Janata Mahavidyalaya, Chandrapur.
            Organized by the Creative Chess Association, Chandrapur, the championship attracted 144 players from
            across Maharashtra, including 73 FIDE-rated players, and was conducted in an 8-round Swiss League
            classical format with a total prize fund of ₹40,000.</p>
        <p>The event concluded successfully with enthusiastic participation, excellent sportsmanship, and smooth
            conduct under the supervision of Chief Arbiter IA Pravin Thakare. The tournament also served as the
            official selection event for the National Championship.</p>

        <h5 class="primary-purple">Winners</h5>
        <div class="row row-cols-md-2">
            <div class="col">
                <p><strong>Under-11 Open</strong></p>
                <ul class="list-style list-style1 mb-3">
                    <li>Winner: Medhansh Dinesh Poojary (Mumbai Suburban) – 7 Points</li>
                    <li>Runner-up: Korde Tirth (Pune) – 6½ Points</li>
                    <li>Second Runner-up: Patil Varad Sayaji (Sangli) – 6½ Points</li>
                </ul>
            </div>
            <div class="col">
                <p><strong>Under-11 Girls</strong></p>
                <ul class="list-style list-style1 mb-3">
                    <li>Winner: Gholap Prisha (Nashik) – 7 Points</li>
                    <li>Runner-up: Girisha Prasanna Pai (Mumbai Suburban) – 6½ Points</li>
                    <li>Second Runner-up: Aashvi Ankit Agarwal (Mumbai Suburban) – 6½ Points</li>
                </ul>
            </div>
        </div>

        <h5 class="primary-purple">Closing Note</h5>
        <p>The G.H. Raisoni Memorial & h2e Power Systems Maharashtra State Under-11 Open & Girls Selection FIDE Rated
            Chess Championship 2026 concluded successfully with remarkable participation, competitive spirit, and
            excellent sportsmanship. The organizers extend their heartfelt gratitude to all players, parents,
            officials, arbiters, volunteers, sponsors, and supporters for making the championship a grand success.
            Congratulations to all the winners and selected players, and best wishes for their upcoming National
            Championship journey. We look forward to welcoming everyone again in future editions of the tournament.
        </p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ms-under-11-open-girls-selection-fide-rated-chess-champ-26.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
